import { Component, Input, inject } from '@angular/core';
import { SafeCheckPipe } from '@boels/helpers';
import { BoelsTeaserComponentData } from '@boels/models';
import { ComponentDataService } from '@boels/shared-state';
import { GenericLinkWrapperComponent } from '../../../generic-link-wrapper/generic-link-wrapper.component';

@Component({
  imports: [SafeCheckPipe, GenericLinkWrapperComponent],
  selector: 'boels-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss'],
})
export class CardComponent {
  private componentDataService = inject(ComponentDataService);

  @Input() cardComponentData: BoelsTeaserComponentData;

  getImageSrc(url = ''): string {
    return this.componentDataService.getImageSrc(url);
  }
}
